document.addEventListener('DOMContentLoaded', (event) => {
    var elem = document.querySelectorAll('.main-hero-banner');
    elem.forEach((element) => {
      var flkty = new Flickity(element, {
        cellAlign: 'left',
        pageDots: true,
        prevNextButtons: false,
        wrapAround: true,
        imagesLoaded: true,
        lazyLoad: true,
      });
    });
});